import { render, staticRenderFns } from "./r1.vue?vue&type=template&id=71b62146&scoped=true&"
import script from "./r1.vue?vue&type=script&lang=js&"
export * from "./r1.vue?vue&type=script&lang=js&"
import style0 from "./r1.vue?vue&type=style&index=0&id=71b62146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b62146",
  null
  
)

export default component.exports